var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"p-0 overflow-hidden"},[_c('youtube',{ref:_vm.video,attrs:{"fitParent":true,"video-id":_vm.video,"player-vars":_vm.playerVars},on:{"playing":_vm.playing,"ended":_vm.ended,"paused":_vm.paused}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }